import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import LoginScreen from '../screens/LoginScreen'
import { ensureUniversalLoginContext } from '@/utils/helpers/universalLoginContext.ts'

async function bootstrap() {
  await ensureUniversalLoginContext('login')
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <LoginScreen />
    </StrictMode>,
  )
}

bootstrap()
